import {Component, EventEmitter, Output} from '@angular/core';

/**
 * the regex that represent the security policy (at least 8 characters with figures,lower and upper Case)
 * @type {string}
 */
const regexPassword = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#\\-\\$_%\\^\\+!\\*=])[0-9a-zA-Z@#\\-\\$_%\\^\\+!\\*=]{12,}';

/**
 * component that permit to create new password
 */
@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})
export class CreatePasswordComponent {

  /**
   * handle the notification when the password change
   */
  @Output()
  public passwordEvent: EventEmitter<string> = new EventEmitter<string>();

  /**
   * handle the notification when the verificationPassword change
   */
  @Output()
  public verifyPasswordEvent: EventEmitter<string> = new EventEmitter<string>();

  /**
   * handle the confirmation if the new Password match the policy rules
   */
  @Output()
  public isNewPasswordValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  /**
   * handle the confirmation if the new Password match the policy rules
   */
  @Output()
  public isNewPasswordConfirmValid: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * the password that the user wants to create
   */
  public password: string;

  /**
   * the confirmation password (he have to type 2 times)
   */
  public verifyPassword: string;

  public passwordIsvalid: boolean;
  public passwordConfirmIsValid: boolean;
  /**
   * the default constructor: do nothing special
   */
  constructor() {
    this.passwordIsvalid = true;
    this.passwordConfirmIsValid = true;
  }

  /**
   *
   * function that check if the password and the verification password are not null and equals
   *
   * @return {boolean} - true if the password match, false else
   */
  private passwordMatches(): boolean {
    if (this.password) {
      return this.password === this.verifyPassword;
    }
    return true;
  }

  /**
   *
   * verify if the password is correct regarding the security policy
   *
   * @return {boolean}
   */
  private newPasswordMatchCriterias(): boolean {
    return new RegExp(regexPassword).test(this.password);
  }

  /**
   *
   * check the validity of passwords inputs
   *
   * @return {boolean} - true if the passwords are the same and they match the security policy
   */
  public checkValidity(): boolean {
    return this.passwordMatches() && this.newPasswordMatchCriterias();
  }

  /**
   *
   * handle the propagation of event when the password / the verifyPasswordEvent changes
   *
   */
  public notify(): void {
    this.passwordEvent.emit(this.password);
    this.verifyPasswordEvent.emit(this.verifyPassword);
    this.passwordIsvalid = this.newPasswordMatchCriterias();
    this.passwordConfirmIsValid = this.passwordMatches();
    this.isNewPasswordValid.emit(this.passwordIsvalid);
    this.isNewPasswordConfirmValid.emit(this.passwordConfirmIsValid);
  }


}
